
import MSGReader from './msgReader/msgReader';
import { createMSGPreviewTemplate } from "./createMSGPreviewTemplate";

export const previewMSGFile = async (file: File) => {
  const fileReader = new FileReader();
  fileReader.onload = function (evt: any) {
    const buffer = evt.target.result;
  const reader = MSGReader(buffer);
  //@ts-ignore
  const msg = reader.getFileData();

  // Prepare HTML content
   const htmlContent = createMSGPreviewTemplate(msg);

  // Open in new tab
  const newWindow = window.open();
  if (newWindow) {
    newWindow.document.open();
    newWindow.document.write(htmlContent);
    newWindow.document.close();
  } else {
    alert("Pop-up blocked. Please allow pop-ups for this site.");
  }
  }
  fileReader.readAsArrayBuffer(file);
  
};
